module.exports = __webpack_public_path__ + "ui-static/img/videos-no-items_dark.3056f0e0.svg";